import axios from 'axios'

export default {
    getServiceCompanyList(country, state, city, address, zip, serviceCompany, allowedDistance) {
        var url = `/api/customers/service?country=${country}&state=${state}`;
        if (city) {
            url = url + '&city=' + city;
        }
        if (address) {
            url = url + '&address=' + address;
        }
        if (zip) {
            url = url + '&zip=' + zip;
        }
        if (serviceCompany) {
            url = url + '&serviceCompany=' + serviceCompany;
        }
        if (allowedDistance) {
            url = url + '&allowedDistance=' + allowedDistance;
        }
        // return axios.get(`/api/customers/service?country=${country}&state=${state}&city=${city}&address=${address}&zip=${zip}&serviceCompany=${serviceCompany}`);
        return axios.get(url);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/shared/components/companyselector/api.js